module.exports = __webpack_public_path__ + "img/11.cd3c7908.jpg";